import { fetchClientDetails } from '@/lib/api';

export default {
  state: {
    clientDetails: {},
    loading: true,
  },

  getters: {
    isLoadingClientDetails({ loading }) {
      return loading;
    },
    clientDetails({ clientDetails }) {
      return clientDetails;
    },
    feeData(state) {
      if (state.clientDetails && state.clientDetails.incepted_accounts_exist) {
        return {
          fee_summary: state.clientDetails.statement.fee_summary,
          fee_breakdown: state.clientDetails.statement.fees,
        };
      }
      return null;
    },
    holdingData(state) {
      if (state.clientDetails && state.clientDetails.incepted_accounts_exist && state.clientDetails) {
        return state.clientDetails.statement.holdings;
      }
      return null;
    },
    usdToCadExchangeRate(state) {
      if (state.clientDetails && state.clientDetails.incepted_accounts_exist) {
        return state.clientDetails.statement.usd_to_cad_exchange_rate;
      }
      return null;
    },
    activityData(state) {
      if (state.clientDetails && state.clientDetails.incepted_accounts_exist) {
        return state.clientDetails.statement.activity;
      }
      return null;
    },
    inceptionDate(state) {
      if (state.clientDetails && state.clientDetails.incepted_accounts_exist) {
        return state.clientDetails.statement.oldest_account_inception_date;
      }
      return null;
    },
  },

  mutations: {
    setLoadingClientDetails(state, loading) {
      state.loading = loading;
    },
    updateClientDetails(state, clientDetails) {
      state.clientDetails = clientDetails;
    },
  },

  actions: {
    async fetchClientDetails({ commit }, { clientId, timeSpan }) {
      commit('setLoadingClientDetails', true);
      commit('updateClientDetails', {});
      const clientDetails = await fetchClientDetails.execute(clientId, timeSpan);
      commit('updateClientDetails', clientDetails);
      commit('setLoadingClientDetails', false);
      return clientDetails;
    },
  },
};
